import { render, staticRenderFns } from "./PackageSize.vue?vue&type=template&id=0a2a84f3&scoped=true&"
import script from "./PackageSize.vue?vue&type=script&lang=js&"
export * from "./PackageSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a84f3",
  null
  
)

export default component.exports